<app-content-auth>
	<app-request-password></app-request-password>
</app-content-auth>
